import React, { useRef, useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const MobileSlider = ({ children, showDots = true, className = '' }) => {
  const scrollRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [totalSlides, setTotalSlides] = useState(0);

  useEffect(() => {
    if (scrollRef.current) setTotalSlides(scrollRef.current.children.length);
  }, [children]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    const handleScroll = () => {
      const index = Math.round(container.scrollLeft / container.offsetWidth);
      setActiveIndex(index);
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (index) => {
    if (scrollRef.current) scrollRef.current.scrollTo({ left: scrollRef.current.offsetWidth * index, behavior: 'smooth' });
  };

  return (
    <div className={`relative ${className}`}>
      <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-0" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}>
        {React.Children.map(children, (child, i) => (
          <div key={i} className="w-full flex-shrink-0 snap-center px-2">{child}</div>
        ))}
      </div>
      {totalSlides > 1 && (
        <div className="flex items-center justify-center gap-3 mt-5">
          <button onClick={() => activeIndex > 0 && scrollTo(activeIndex - 1)} disabled={activeIndex === 0} className="w-8 h-8 rounded-xl border border-[#E2E2F0] flex items-center justify-center text-[#6366F1] hover:bg-[#6366F1] hover:text-white hover:border-[#6366F1] disabled:opacity-30 transition-all bg-white">
            <ChevronLeft className="w-4 h-4" />
          </button>
          {showDots && (
            <div className="flex items-center gap-1.5">
              {Array.from({ length: totalSlides }).map((_, i) => (
                <button key={i} onClick={() => scrollTo(i)} className={`rounded-full transition-all duration-300 ${i === activeIndex ? 'w-6 h-2 bg-[#6366F1]' : 'w-2 h-2 bg-[#E2E2F0]'}`} />
              ))}
            </div>
          )}
          <button onClick={() => activeIndex < totalSlides - 1 && scrollTo(activeIndex + 1)} disabled={activeIndex === totalSlides - 1} className="w-8 h-8 rounded-xl border border-[#E2E2F0] flex items-center justify-center text-[#6366F1] hover:bg-[#6366F1] hover:text-white hover:border-[#6366F1] disabled:opacity-30 transition-all bg-white">
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      )}
    </div>
  );
};

export default MobileSlider;
